export default class VRCover {
    constructor() {
        this.initStyles();
        this.mainElement = document.createElement('div');
        this.mainElement.classList.add('vr_cover');
        const text = document.createElement('div');
        text.classList.add('vr_cover_text');
        text.innerHTML = 'PLEASE ENTER VR MODE';
        this.mainElement.appendChild(text);
    }
    initStyles() {
        const styles = document.createElement('style');
        styles.innerHTML = `
        .vr_cover {
            position: absolute;
            top: 0;
            left: 0;
            z-index: 100;

            background: #333333;

            width: 100vw;
            height: 100vh;
            display: block;
        }

        .vr_cover_text {
            position: absolute;
            left: 50%;
            top: 45%;

            transform: translate(-50%, -50%);

            color: white;
        }
        `;
        document.head.appendChild(styles);
    }
    show() {
        document.body.appendChild(this.mainElement);
    }
    hide() {
        document.body.removeChild(this.mainElement);
    }
}
